/**
 * DriverStatusBadge — colored pill showing driver availability
 */
export default function DriverStatusBadge({ status, size = 'md' }) {
  const config = {
    available: { label: 'Available', color: 'bg-green-500/20 text-green-400 border-green-500/30' },
    busy: { label: 'On Delivery', color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30' },
    offline: { label: 'Offline', color: 'bg-gray-500/20 text-gray-400 border-gray-500/30' },
  };

  const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  const { label, color } = config[status] || config.offline;

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${color} ${sizeClass}`}>
      <span
        className={`w-1.5 h-1.5 rounded-full ${
          status === 'available' ? 'bg-green-400 animate-pulse' :
          status === 'busy' ? 'bg-yellow-400' : 'bg-gray-400'
        }`}
      />
      {label}
    </span>
  );
}

/**
 * DeliveryStatusBadge — colored pill for delivery job status
 */
export function DeliveryStatusBadge({ status }) {
  const config = {
    pending: { label: 'Pending', color: 'bg-gray-500/20 text-gray-300 border-gray-500/30' },
    assigned: { label: 'Assigned', color: 'bg-blue-500/20 text-blue-400 border-blue-500/30' },
    accepted: { label: 'Accepted', color: 'bg-purple-500/20 text-purple-400 border-purple-500/30' },
    picked_up: { label: 'Picked Up', color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30' },
    delivered: { label: 'Delivered', color: 'bg-green-500/20 text-green-400 border-green-500/30' },
    cancelled: { label: 'Cancelled', color: 'bg-red-500/20 text-red-400 border-red-500/30' },
  };

  const { label, color } = config[status] || config.pending;

  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full border text-sm font-medium ${color}`}>
      {label}
    </span>
  );
}
